import {
    USER_RESET_PASSWORD_SUCCESS,
    USER_RESET_PASSWORD_FAILURE,
    USER_CHECK_TOKEN_FAILURE,
    USER_CHECK_TOKEN_SUCCESS,
    USER_RESET_PASSWORD_REQUEST
} from "./constants";
import {USER_VERIFY_REQUEST} from "../VerifyUser/constants";

const initialState = {
    checkingToken: undefined,
    resetSuccess: undefined,
    error: ''
};

const resetPasswordReducer = (state = initialState, action) => {

    switch (action.type) {
        case USER_VERIFY_REQUEST: {
            return Object.assign({}, state, {checkingToken: true});
        }
        case USER_RESET_PASSWORD_REQUEST: {
            return Object.assign( {}, state, {resetSuccess: undefined, error: ''} );
        }
        case USER_RESET_PASSWORD_SUCCESS: {
            return Object.assign( {}, state, {resetSuccess: true} );
        }
        case USER_RESET_PASSWORD_FAILURE: {
            return Object.assign( {}, state, {resetSuccess: false, error: action.data.error.validationErrors.error} );
        }
        case USER_CHECK_TOKEN_SUCCESS: {
            return Object.assign( {}, state, {checkingToken: true} );
        }
        case USER_CHECK_TOKEN_FAILURE: {
            return Object.assign( {}, state, {checkingToken: false} );
        }
        default: {
            return state;
        }
    }
};

export default resetPasswordReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ResetPassword/reducer.js